import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'cdp-iframe',
    styleUrls: ['./iframe.component.scss'],
    template: ` <iframe [src]="safeIframeSrc"></iframe> `,
    standalone: false
})
export class IFrameComponent implements OnChanges {
    @Input()
    public src?: string;

    protected safeIframeSrc?: SafeResourceUrl;

    constructor(private sanitizer: DomSanitizer) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes['src']) {
            this.safeIframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.src ?? '');
        }
    }
}
